/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class s {
  get value() {
    return this.o;
  }
  set value(s2) {
    this.setValue(s2);
  }
  setValue(s2, t = false) {
    const i = t || !Object.is(s2, this.o);
    this.o = s2, i && this.updateObservers();
  }
  constructor(s2) {
    this.subscriptions = /* @__PURE__ */ new Map(), this.updateObservers = () => {
      for (const [s3, { disposer: t }] of this.subscriptions)
        s3(this.o, t);
    }, void 0 !== s2 && (this.value = s2);
  }
  addCallback(s2, t, i) {
    if (!i)
      return void s2(this.value);
    this.subscriptions.has(s2) || this.subscriptions.set(s2, { disposer: () => {
      this.subscriptions.delete(s2);
    }, consumerHost: t });
    const { disposer: h } = this.subscriptions.get(s2);
    s2(this.value, h);
  }
  clearCallbacks() {
    this.subscriptions.clear();
  }
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class e extends Event {
  constructor(t) {
    super("context-provider", { bubbles: true, composed: true }), this.context = t;
  }
}
class ContextProvider extends s {
  constructor(root, context, initialValue) {
    super(initialValue);
    this.root = root;
    this.context = context;
    this.onContextRequest = (ev) => {
      const consumerHost = ev.composedPath()[0];
      if (ev.context !== this.context || consumerHost === this.root) {
        return;
      }
      ev.stopPropagation();
      this.addCallback(ev.callback, consumerHost, ev.subscribe);
    };
    this.attachListeners();
    this.root.dispatchEvent(new e(context));
  }
  attachListeners() {
    this.root.addEventListener("context-request", this.onContextRequest);
  }
  removeListeners() {
    this.root.removeEventListener("context-request", this.onContextRequest);
  }
}
class GenericContextProvider {
  constructor(root = document) {
    this.root = root;
    this.provided = [];
  }
  provide(context, initialValue) {
    this.provided.push(new ContextProvider(this.root, context, initialValue));
  }
  destroy() {
    this.provided.forEach((provided) => {
      provided.removeListeners();
    });
  }
}
export {
  GenericContextProvider
};
//# sourceMappingURL=generic-provider.js.map
